import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#050507] border-t border-white/[0.06]">
      {/* Top statement band */}
      <div className="border-b border-white/[0.06] py-20 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
          <h2
            className="font-extrabold text-white leading-[0.95] tracking-[-0.04em] max-w-2xl"
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: "clamp(2rem, 4vw, 3.5rem)",
            }}
          >
            Intelligence that holds{" "}
            <span style={{
              background: "linear-gradient(135deg, #4ADE80, #22C55E)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}>
              everything together.
            </span>
          </h2>
          <a
            href="#get-started"
            className="whitespace-nowrap flex-shrink-0 px-8 py-4 rounded-full bg-[#4ADE80] text-[#050507] font-bold text-sm hover:bg-[#22C55E] hover:scale-105 transition-all duration-200 cursor-pointer"
          >
            Build My Foundation
          </a>
        </div>
      </div>

      {/* Main footer grid */}
      <div className="py-16 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/737439b21121152bcfa7b4fdd551ee4d.png"
              alt="GroundsWell AI"
              className="h-[90px] w-[90px] object-contain mb-5"
            />
            <p className="text-sm text-white/35 leading-relaxed max-w-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
              Structured AI systems that stabilize operations and turn growth into a predictable, repeatable outcome.
            </p>
          </div>

          {/* Pages */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-white/25 mb-5">Pages</p>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Services", path: "/services" },
                { label: "Industries", path: "/industries" },
              ].map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-sm text-white/45 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-white/25 mb-5">Services</p>
            <ul className="space-y-3">
              {["Foundation Systems", "Workflow Structuring", "Scale Infrastructure"].map((s) => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="text-sm text-white/45 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/20" style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; {new Date().getFullYear()} GroundsWell AI. All rights reserved.
          </p>
          <p className="text-xs text-white/20" style={{ fontFamily: "'Inter', sans-serif" }}>
            Built on Intelligence. Designed to Last.
          </p>
        </div>
      </div>
    </footer>
  );
}
